import Header from '../components/Header';
import Footer from '../components/Footer';
import { SHOP_DROPDOWN, CALENDAR_DROPDOWN } from '../components/navConfig';

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { label: 'Shop', dropdown: SHOP_DROPDOWN('') },
  CALENDAR_DROPDOWN(''),
  { to: '/daily', label: 'Daily OBX', active: true },
];

const FOOTER_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/admin/login', label: 'Admin' },
];

function DailyOBXComingSoon() {
  return (
    <div className="substack-site" style={{ background: '#fafafa' }}>
      {/* Header */}
      <Header navItems={NAV_ITEMS} />

      {/* Main Content */}
      <main style={{
        maxWidth: '700px',
        margin: '0 auto',
        padding: '100px 20px 120px',
        textAlign: 'center'
      }}>
        <img
          src="https://daily-obx-cdn.b-cdn.net/newsletter-images/dailyobx.jpg"
          alt="Daily OBX"
          style={{
            maxWidth: '400px',
            width: '90%',
            height: 'auto',
            marginBottom: '50px',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        />

        <h1 style={{
          fontFamily: "'Playfair Display', Georgia, serif",
          fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
          fontWeight: '400',
          lineHeight: '1.3',
          color: '#1a1a1a',
          marginBottom: '20px'
        }}>
          Coming Soon
        </h1>

        <p style={{
          fontSize: '1.15rem',
          lineHeight: '1.8',
          color: '#555',
          marginBottom: '10px'
        }}>
          A little piece of the Outer Banks in your inbox every morning.
        </p>
        <p style={{
          fontSize: '1.15rem',
          lineHeight: '1.8',
          color: '#555'
        }}>
          Daily OBX is on its way — check back soon.
        </p>
      </main>

      {/* Footer */}
      <Footer links={FOOTER_LINKS} />
    </div>
  );
}

export default DailyOBXComingSoon;
